module.exports = __webpack_public_path__ + "static/img/shang-pin.b1c3e94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shang-pin.jpg
// module id = Ke59
// module chunks = 36